// Route guard for screens that require an authenticated session.
// Wraps the protected element; redirects to /login when no session
// is present. Authorization (admin role, facility_management vertical)
// is enforced by the API — this is UX-only.

import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { useSession } from "./useSession";

export function RequireAuth({ children }: { children: ReactNode }) {
  const session = useSession();
  const location = useLocation();
  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return <>{children}</>;
}
